<template>
  <div>
    <!-- 创建具体要求 -->
    <el-dialog :title="$t('message.createSpecificRequirements')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="1280px" center>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
        <!-- 任务类型 -->
        <el-form-item :label="$t('message.taskType')" prop="type">
          <el-select v-model="ruleForm.type" :placeholder="$t('message.taskType') + ':'" clearable filterable
            placeholder="任务类型">
            <el-option v-for="item in options" :key="item.key" :label="item.name" :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 具体要求 -->
        <el-form-item :label="$t('message.specificRequirements') + ':'" prop="desc">
          <el-input v-model="ruleForm.desc" type="textarea" placeholder="请输入您要抽查内容的具体明细"></el-input>
        </el-form-item>
        <!-- 参考标准 -->
        <el-form-item :label="$t('message.specificRequirementsReferenceStandard') + ':'">
          <quill-editor ref="myTextEditor" id="quill-editor" v-model="ruleForm.content" :options="quillOption">
          </quill-editor>
        </el-form-item>
        <!-- 备注 -->
        <el-form-item :label="$t('message.remark') + ':'">
          <el-input v-model="ruleForm.remark" type="textarea" placeholder="请输入备注内容"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <!-- 保存 -->
        <el-button type="primary" @click="expectStore">
          {{ $t("message.save") }}
        </el-button>
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { quillEditor } from "vue-quill-editor";
import quillConfig from "@/utlis/quill-config";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  props: {
    options: { type: Array }
  },
  components: {
    quillEditor
  },
  data() {
    return {
      quillOption: quillConfig,
      ruleForm: {},
      rules: {
        type: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
        desc: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },]
      },
      dialogVisible: false,
    };
  },
  methods: {
    expectStore() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$api.spotCheckApi.expectStore(this.ruleForm).then(res => {
            this.$message.success(res.msg)
            this.$parent.expectList()
            this.dialogVisible = false
          })
        }
      })
    },
  },
};
</script>
<style lang='scss' scoped>
/deep/.el-form-item__label {
  float: none;
}

/deep/.el-textarea__inner {
  height: 200px !important;
}

/deep/ .ql-container {
  height: 200px !important;
}
</style>